// Day 1 = Red, Day 2 = Blue per spec; days 3-7 continue with distinct,
// legible colours for the legend/map/date chips.
export const DAY_COLORS = [
  "#E53935", // Day 1 - Red
  "#1E88E5", // Day 2 - Blue
  "#43A047", // Day 3 - Green
  "#8E24AA", // Day 4 - Purple
  "#FB8C00", // Day 5 - Orange
  "#00897B", // Day 6 - Teal
  "#D81B60", // Day 7 - Pink
];

export const getDayColor = (dayIndex: number) =>
  DAY_COLORS[dayIndex % DAY_COLORS.length];
